import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import sendAppLink from './sendAppLink';
import { SEND_APP_LINK } from 'app/constants';


export default function* watchAppLink() {
  yield fork(takeLatest, SEND_APP_LINK, sendAppLink);
}
